import 'vue-svgicon/dist/polyfill'
import Vue from 'vue'
import SvgIcon from 'vue-svgicon'
import '../assets/icons/js'

Vue.use(SvgIcon)
